module.exports = "/_next/static/images/2e8522369cbe6ea501f929b82fa81c8d-desktop-lg.jpg.webp";